/// <amd-module name="Dashboards/WidgetContracts/Internal/LegacyConfigProps" />
import { ConfigProps } from "./ConfigProps";
import { WidgetGridSize } from "./DashboardWidgetProps";

/** In legacy, the framework, rather than Widget config managed Name/Title and size, where new plat configs directly deal with these concerns.
 *  Legacy API's allowed first party config experiences to interact with these aspects. */
export interface LegacyConfigRuntimeProps {
    /** returns the current name of the widget, as managed by framework, on behalf of legacy configuration. */
    getCurrentWidgetName(): string;

    /** sets current name of the widget, as managed by framework, on behalf of legacy configuration */
    setCurrentWidgetName(name: string): void;

    /** returns the current size of the widget, as managed by framework, on behalf of legacy configuration */
    getCurrentWidgetSize(): WidgetGridSize;
}

/**
 * @deprecated Interface for the object passed to the host when user clicks on the Save button in the configuration pane
 */
export interface LegacySaveStatus {
    /**
     * Indicates validity of the customSettings. If false, then user will be shown a generic error message and settings will not be saved.
     */
    isValid: boolean;
}

/**  @deprecated Callbacks exposed from Legacy Config Experiences */
export interface LegacyConfigCallbacks {
    /**
     * Called by the host when the user clicks on the Save button.
     * Widget author is expected to run validations if needed.
     * If ready to save, then use WidgetHelpers.WidgetConfigurationSave.Valid() to return the serialized custom settings of the widget from the configuraton.
     * If custom settings are not valid and so not ready to save, then  use WidgetHelpers.WidgetConfigurationSave.Invalid() to notify the host to stop save.
     * @returns object of type SaveStatus wrapped in a promise.
     */
    onSave: () => Promise<LegacySaveStatus>;

    /**
     * (Optional) Called by the host when the configuration is ready to be saved (when the user clicks the save button on the configuration panel)
     */
    onSaveComplete?: () => void;
}

export interface LegacyConfigProps extends ConfigProps {
    /**
     * Legacy contribution type Identifier for the widget as in the manifest.
     */
    legacyRuntimeProps: LegacyConfigRuntimeProps;
    /** Allows Legacy Config Host to register for notifications under legacy pattern */
    registerCallbacks: (callbacks: LegacyConfigCallbacks) => void;
}
